module.exports = __webpack_public_path__ + "static/sponsorship_img-07-d-3c7f9f1cdef9b423407d683d873489e8.jpg";